var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'trustedIcons',
        ("trustedIcons--" + _vm.align),
        { 'trustedIcons--large': _vm.large, 'trustedIcons--twoRows': _vm.twoRows } ]},[_c('span',{staticClass:"trustedIcons__title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('SVGIcon',{staticClass:"icon__trusted icon__trusted--insured",attrs:{"icon-name":"insured-by"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }